import { getMetricAggregatesHiddenEnabled } from 'common/featureFlag';

/**
 * NOTE: This type is intentionally duplicated from 'column-model.ts' to
 * break a circular dependency between core models and feature flag utilities.
 *
 * TODO: Remove this file once the 'getMetricAggregatesHiddenEnabled' flag is retired
 * and deprecated aggregation modes are fully removed from the codebase.
 */
type AggregationMode = 'average' | 'last' | 'max' | 'min' | 'variance';

const FLOAT_SERIES_DEPRECATED_AGGREGATION_MODES: AggregationMode[] = [
  'average',
  'max',
  'min',
  'variance',
];

const FLOAT_SERIES_ALL_SUBPROPERTIES: AggregationMode[] = [
  'average',
  'last',
  'max',
  'min',
  'variance',
];

const FLOAT_SERIES_SUBPROPERTIES_WHEN_DEPRECATED_HIDDEN: AggregationMode[] = ['last'];

export function isDeprecatedFloatSeriesAggregationMode(
  aggregationMode: string | undefined,
): boolean {
  return (
    isFloatSeriesAggregationMode(aggregationMode) &&
    FLOAT_SERIES_DEPRECATED_AGGREGATION_MODES.includes(aggregationMode)
  );
}

export function isFloatSeriesAggregationMode(value: string | undefined): value is AggregationMode {
  return (
    value === 'average' ||
    value === 'last' ||
    value === 'max' ||
    value === 'min' ||
    value === 'variance'
  );
}

export function getDefaultFloatSeriesSubproperties(): AggregationMode[] {
  return getMetricAggregatesHiddenEnabled()
    ? FLOAT_SERIES_SUBPROPERTIES_WHEN_DEPRECATED_HIDDEN
    : FLOAT_SERIES_ALL_SUBPROPERTIES;
}
